var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFluentCheckmarkCircle24Regular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fluent:checkmark-circle-24-regular"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.0003 2.16699C14.6028 2.16699 18.3337 5.89783 18.3337 10.5003C18.3337 15.1028 14.6028 18.8337 10.0003 18.8337C5.39783 18.8337 1.66699 15.1028 1.66699 10.5003C1.66699 5.89783 5.39783 2.16699 10.0003 2.16699ZM10.0003 3.41699C8.12171 3.41699 6.32004 4.16327 4.99165 5.49165C3.66327 6.82004 2.91699 8.62171 2.91699 10.5003C2.91699 12.3789 3.66327 14.1806 4.99165 15.509C6.32004 16.8374 8.12171 17.5837 10.0003 17.5837C11.8789 17.5837 13.6806 16.8374 15.009 15.509C16.3374 14.1806 17.0837 12.3789 17.0837 10.5003C17.0837 8.62171 16.3374 6.82004 15.009 5.49165C13.6806 4.16327 11.8789 3.41699 10.0003 3.41699ZM8.95866 11.7003L12.6837 7.97533C12.7953 7.86453 12.9447 7.79991 13.1019 7.79438C13.2591 7.78884 13.4126 7.84279 13.5318 7.94546C13.651 8.04813 13.7271 8.19196 13.7449 8.34826C13.7627 8.50456 13.7209 8.66182 13.6278 8.78866L13.567 8.85866L9.40033 13.0253C9.2945 13.1312 9.15421 13.1955 9.00495 13.2067C8.85569 13.2179 8.70738 13.1751 8.58699 13.0862L8.51699 13.0253L6.43366 10.942C6.32286 10.8303 6.25825 10.681 6.25271 10.5238C6.24717 10.3666 6.30112 10.213 6.40379 10.0939C6.50646 9.97468 6.6503 9.8986 6.80659 9.88079C6.96289 9.86299 7.12015 9.90478 7.24699 9.99783L7.31699 10.0587L8.95866 11.7003Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFluentCheckmarkCircle24Regular);
export default __webpack_public_path__ + "static/media/fluent_checkmark-circle-24-regular.083b8ecea4ce19844914022c6e7ba17b.svg";
export { ForwardRef as ReactComponent };